export default __webpack_public_path__ + "img/4803800d1d5ec0898825808104cf6539.svg";